// extracted by mini-css-extract-plugin
export default {"title":"GuideAuthorsContent-module__title-rBFu","description":"GuideAuthorsContent-module__description-ZcRn"};